import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, MarkExtension, ExtensionTag, isElementDomNode, ExtensionPriority, isString, omitExtraAttributes, joinStyles } from '@remirror/core';

var _dec, _dec2, _dec3, _class, _class2;
var FONT_FAMILY_ATTRIBUTE = 'data-font-family';
var FontFamilyExtension = (_dec = extension({}), _dec2 = command(), _dec3 = command(), _dec(_class = (_class2 = class FontFamilyExtension extends MarkExtension {
  get name() {
    return 'fontFamily';
  }

  createTags() {
    return [ExtensionTag.FontStyle, ExtensionTag.FormattingMark];
  }

  createMarkSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({}, override), {}, {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        fontFamily: {
          default: null
        }
      }),
      parseDOM: [{
        tag: "span[".concat(FONT_FAMILY_ATTRIBUTE, "]"),
        getAttrs: dom => {
          if (!isElementDomNode(dom)) {
            return false;
          }

          var fontFamily = dom.getAttribute(FONT_FAMILY_ATTRIBUTE);

          if (!fontFamily) {
            return false;
          }

          return _objectSpread(_objectSpread({}, extra.parse(dom)), {}, {
            fontFamily
          });
        }
      }, {
        // Get the color from the css style property. This is useful for pasted content.
        style: 'font-family',
        priority: ExtensionPriority.Low,
        getAttrs: fontFamily => {
          if (!isString(fontFamily)) {
            return false;
          }

          return {
            fontFamily: fontFamily ? fontFamily.replace(/["']/g, '') : ''
          };
        }
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: mark => {
        var _ref = omitExtraAttributes(mark.attrs, extra),
            fontFamily = _ref.fontFamily;

        var extraAttrs = extra.dom(mark);
        var style = extraAttrs.style;
        style = joinStyles({
          fontFamily
        }, style);
        return ['span', _objectSpread(_objectSpread({}, extraAttrs), {}, {
          style,
          [FONT_FAMILY_ATTRIBUTE]: fontFamily
        }), 0];
      }
    });
  }
  /**
   * Set the font family for the selected text.
   */


  setFontFamily(fontFamily) {
    return this.store.commands.applyMark.original(this.type, {
      fontFamily
    });
  }
  /**
   * Set the font family for the selected text.
   */


  toggleFontFamily(fontFamily) {
    return this.store.commands.toggleMark.original({
      type: this.type,
      attrs: {
        fontFamily
      }
    });
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "setFontFamily", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "setFontFamily"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleFontFamily", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleFontFamily"), _class2.prototype)), _class2)) || _class);

export { FontFamilyExtension };
